if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = null;
        this.currentIndex = 0;
        this.images = [];
        this.thumbnails = [];
        this.zoomLevel = 2;
      }

      hide() {
        super.hide();
        this.cleanupZoom();
      }

      show(opener) {
        super.show(opener);
        this.initModal();
      }

      initModal() {
        // Get all product images
        this.images = Array.from(this.querySelectorAll('[data-media-id]'));
        this.thumbnails = Array.from(this.querySelectorAll('.thumbnail'));
        this.currentIndex = this.thumbnails.findIndex(t => t.hasAttribute('aria-current')) || 0;

        // Create modal structure
        this.modalContent = this.querySelector('.product-media-modal__content');
        if (!this.modalContent) return;

        // Add navigation arrows
        this.addNavigationArrows();
        
        // Setup thumbnails
        this.setupThumbnails();
        
        // Setup keyboard navigation
        this.setupKeyboardNavigation();
        
        // Show initial image
        this.showImage(this.currentIndex);
      }

      addNavigationArrows() {
        const prevArrow = document.createElement('button');
        prevArrow.className = 'modal-arrow modal-arrow--prev';
        prevArrow.innerHTML = '<span class="svg-wrapper">{{ "icon-caret.svg" | inline_asset_content }}</span>';
        prevArrow.addEventListener('click', () => this.navigateImage('prev'));

        const nextArrow = document.createElement('button');
        nextArrow.className = 'modal-arrow modal-arrow--next';
        nextArrow.innerHTML = '<span class="svg-wrapper">{{ "icon-caret.svg" | inline_asset_content }}</span>';
        nextArrow.addEventListener('click', () => this.navigateImage('next'));

        this.modalContent.appendChild(prevArrow);
        this.modalContent.appendChild(nextArrow);
      }

      setupThumbnails() {
        const thumbnailsContainer = this.querySelector('.modal-thumbnails-bar');
        if (!thumbnailsContainer) return;

        this.thumbnails.forEach((thumb, index) => {
          thumb.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.showImage(index);
          });
        });
      }

      setupKeyboardNavigation() {
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') {
            this.navigateImage('prev');
          } else if (e.key === 'ArrowRight') {
            this.navigateImage('next');
          } else if (e.key === 'Escape') {
            this.hide();
          }
        });
      }

      navigateImage(direction) {
        const newIndex = direction === 'prev' 
          ? (this.currentIndex - 1 + this.images.length) % this.images.length
          : (this.currentIndex + 1) % this.images.length;
        this.showImage(newIndex);
      }

      showImage(index) {
        this.cleanupZoom();
        
        // Update active states
        this.images.forEach((img, i) => {
          img.classList.toggle('active', i === index);
        });
        
        this.thumbnails.forEach((thumb, i) => {
          thumb.setAttribute('aria-current', i === index);
        });

        // Scroll thumbnail into view
        const activeThumb = this.thumbnails[index];
        if (activeThumb) {
          activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }

        // Setup zoom for the new image
        this.setupZoom(index);
        this.currentIndex = index;
      }

      setupZoom(index) {
        const activeMedia = this.images[index];
        if (!activeMedia) return;

        const img = activeMedia.querySelector('img');
        if (!img) return;

        // Add zoom container
        const zoomContainer = document.createElement('div');
        zoomContainer.className = 'zoom-container';
        activeMedia.appendChild(zoomContainer);

        // Setup zoom functionality
        img.addEventListener('mousemove', (e) => {
          const rect = img.getBoundingClientRect();
          const x = (e.clientX - rect.left) / rect.width * 100;
          const y = (e.clientY - rect.top) / rect.height * 100;
          
          zoomContainer.style.backgroundImage = `url(${img.src})`;
          zoomContainer.style.backgroundSize = `${this.zoomLevel * 100}%`;
          zoomContainer.style.backgroundPosition = `${x}% ${y}%`;
        });

        img.addEventListener('mouseenter', () => {
          zoomContainer.style.display = 'block';
        });

        img.addEventListener('mouseleave', () => {
          zoomContainer.style.display = 'none';
        });
      }

      cleanupZoom() {
        const zoomContainers = this.querySelectorAll('.zoom-container');
        zoomContainers.forEach(container => container.remove());
      }
    }
  );
}
